'use strict';

(function () {
  'use strict';

  angular.module('translations').service('trainStorageSvc', trainStorageSvc);

  angular.module('msActivityServices').service('trainStorageSvc', trainStorageSvc);

  trainStorageSvc.$inject = ['$localStorage', '$q', 'httpSvc'];

  /* @ngInject */
  function trainStorageSvc($localStorage, $q, httpSvc) {
    var promiseCache = null;

    return {
      getTrain: _getTrain,
      fetchTrain: _fetchTrain,
      getStatus: _getStatus,
      getByStatus: _getByStatus,
      getAllActivities: _getAllActivities,
      getTrainActivity: _getTrainActivity,
      containsActivity: _containsActivity,
      getParent: _getParent,
      checkSeriesStatus: _checkSeriesStatus,
      getNextInSeries: _getNextInSeries
    };

    /**
     * Get the current train
     * @param {Boolean} forceRefresh used to force update of train from API
     * @return {Promise(Array)} An array of all the activities in the current train
     */
    function _getTrain(forceRefresh) {
      if (forceRefresh) {
        delete $localStorage.train;
      }
      if (!angular.isUndefined($localStorage.train)) {
        $localStorage.train.status = _getStatus();
        return $q.when($localStorage.train);
      }
      return _fetchTrain();
    }

    /**
     * Get a new train, replacing the old one if it existed
     * @return {Array<Activity>} the new train
     */
    function _fetchTrain() {
      if (promiseCache) {
        return promiseCache;
      }
      promiseCache = httpSvc.get('/apiproxy/user/activities/train').then(function (train) {
        $localStorage.train = train;
        $localStorage.train.status = _getStatus();
        $localStorage.train.type = 'recommended';
        return $localStorage.train;
      }).finally(function () {
        return promiseCache = null;
      });
      return promiseCache;
    }

    /**
     * Find the actual TrainActivity with the same ID as the passed activity.
     * This ensures that we get the correct object when potentially all we have is the ID
     * @param  {Activity} activity The activity to search for
     * @return {TrainActivity}     The activity object actually in the train
     */
    function _getTrainActivity(activity) {
      return _getAllActivities().filter(function (a) {
        return a.id === activity.id;
      })[0];
    }

    /**
     * Get the parent activity of an activity in the train, if one exists
     * @param  {Activity} activity The activity to find as a child
     * @return {Activity}          The parent activity
     */
    function _getParent(activity) {
      return _(_getAllActivities()).find(function (s) {
        return _(s.activities).some(function (c) {
          return c.id === activity.id;
        });
      });
    }

    /**
     * A check to see if the current train actually contains the given activity
     * @param  {String} url The URL of the activity to look for
     * @return {boolean }     true if the activity is in the train, false if not
     */
    function _containsActivity(url) {
      return _getAllActivities().filter(function (a) {
        return a.url === url;
      }).length > 0;
    }

    /**
     * Get status object that includes some rollup statistics on the train
     * @return {Object} An object describing the train
     */
    function _getStatus() {
      var skipped = statusCount('SKIPPED');
      var completed = statusCount('COMPLETED') + skipped;
      var length = getTrainLength();
      return {
        trainLength: length,
        completed: completed,
        toGo: length - completed,
        percentComplete: 100 * completed / length,
        started: completed !== 0,
        done: length === completed
      };
    }

    /**
     * Get all the activities in the train in a flat list. This extracts the activities inside of series and programs
     * @return {List} A list of all activities in order
     */
    function _getAllActivities() {
      if ($localStorage.train) {
        return $localStorage.train.activities.reduce(function (arr, activity) {
          arr.push(activity);
          return activity.activities ? arr.concat(activity.activities) : arr;
        }, []);
      } else {
        return [];
      }
    }

    /**
     * Get the length of the train. This counts all of the activities in the train that are either "CORE" or "YOUTH",
     * ignoring the series, programs and inspirations
     * @return {Integer} The number of total activities in the train
     */
    function getTrainLength() {
      return _getAllActivities().filter(function (activity) {
        return activity.type.normal;
      }).length;
    }

    /**
     * Get the count by status. This doesn't include the inspirations, programs or series
     * @param  {ResponseStatus} status The status to filter the count by
     * @return {Integer}     The number of activities with the given status
     */
    function statusCount(status) {
      status = status || 'COMPLETED';
      return _getByStatus(status).length;
    }

    /**
     * Get all of the activities with the given status
     * @param  {String} status The status to filter by
     * @return {List}        A list of all the activities with the given train status
     */
    function _getByStatus(status) {
      return _getAllActivities().filter(function (activity) {
        return activity.type.normal && activity.responseStatus === status;
      });
    }

    /**
     * Loop through series series and set status to COMPLETED if all activities within series is done.
     */
    function _checkSeriesStatus() {
      var series = _getAllActivities().filter(function (activity) {
        return activity.type.name === 'ACTIVITY_SERIES';
      });
      _.forEach(series, function (s) {
        //set series to completed if all activities are done
        var incomplete = _.find(s.activities, function (a) {
          return a.responseStatus === 'INCOMPLETE';
        });
        if (!incomplete) {
          s.responseStatus = 'COMPLETED';
          s.completed = true;
        }
      });
      //handle case where series was already completed and this is retake
      if (series.current && series.current === series.activity.length - 1) {
        delete series.current;
      }
    }

    /**
     * For completed series, need to get next activity based upon previous one taken since there are no INCOMPLETE activities.
     */
    function _getNextInSeries() {
      var series = _getAllActivities().find(function (activity) {
        return activity.type.name === 'ACTIVITY_SERIES' && _.isInteger(activity.current);
      });
      if (series) {
        series.current++;
        return series.activities[series.current];
      }
      return null;
    }
  }
})();